import { render, staticRenderFns } from "./functionDppm.vue?vue&type=template&id=5e962cbf&scoped=true&"
import script from "./functionDppm.vue?vue&type=script&lang=js&"
export * from "./functionDppm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e962cbf",
  null
  
)

export default component.exports